module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAZCAMAAADpC5XfAAAAXVBMVEVMaXFQUFBQUFBRUVFMTExQUFBVVVVRUVFNTU1RUVFQUFBRUVFRUVFQUFBSUlJQUFBRUVFQUFBPT09PT09NTU1RUVFQUFBQUFBQUFBTU1NQUFBRUVFQUFBSUlJRUVFWFt0kAAAAHnRSTlMAzUvADvwEgAnzmDdVrC95WdUpUhOIuI5uGhya5z5VsDHsAAAArUlEQVR42oXSyQ6EIBRE0QIBwXkeu+v/P7MjMUhsE+/y7N6AjP9lYJLeSwimarG4MsuQHlq5LtLVfb3i3qvavM/tTe3oSLrRxqoEyz7vSwoVaakbHDW6vLTiCPhmdkFrrqdurIPuDjhze9BZmxONnoM2lKdKNkHtp1UeVfuxQSEpKgCV0DKerXBsp5auQKwY6klM9fC2M1OY2ArrNWcX4aalVyjEKaR8vvHzP/wAhMoS7DRrs4UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/icon-voicebox.png
// module id = H1CN
// module chunks = 0